export default {"src":"/_next/static/media/AvatarLight.4ddb9d5a.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};